import {eq} from '@shared/helpers/lang'

import {initOrderSheetByStorage} from '@web/actions/orderSheetInfo'
import {
    APIStatus,
    PayMoneyUserStatus,
    NaverPointStatus,
    PayMethod,
    PayMoneyUserStatusList,
    ApiResult,
} from '@web/core/constants'
import {getNaverPayPointByApi} from '@web/pageHelpers/ordersheet'
import {getNaverPayPointAmount} from '@web/slices/pointPayment/slice'
import makeSlice from '@web/slices/pointPayment/sliceMaker'

import {initOrderSheetByAPI} from '../../actions'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder
            .addCase(initOrderSheetByStorage.fulfilled, (state, {payload}) => {
                const {data} = payload
                state.naverPayPoint.usingAmount = data.pointPayment.naverPayPoint.usingAmount
                state.naverPayPoint.usePointAll = data.pointPayment.naverPayPoint.usePointAll
            })
            .addCase(initOrderSheetByAPI.fulfilled, (state, {payload: {naverpayPoint, availablePayMethodTypes}}) => {
                const {
                    rewardPoint,
                    chargePoint,
                    usePointAll,
                    exposeAmlGuideMessage,
                    pointExhaustionListAvailable,
                    preferredPointExhaustionList,
                } = naverpayPoint ?? getNaverPayPointByApi()

                const isPayMoneyUser = PayMoneyUserStatusList.includes(
                    chargePoint?.chargePointUser?.userStatus ?? PayMoneyUserStatus.NOT_OPEN,
                )
                const isRewardPointAvailable = availablePayMethodTypes.includes(PayMethod.REWARD_POINT)
                const isChargePointAvailable = availablePayMethodTypes.includes(PayMethod.CHARGE_POINT)

                state.naverPayPoint.amount = getNaverPayPointAmount({
                    rewardPoint: isRewardPointAvailable ? (rewardPoint?.rewardPointBalance ?? 0) : 0,
                    chargePoint: isChargePointAvailable ? (chargePoint?.chargePointBalance?.availableBalance ?? 0) : 0,
                    isPayMoneyUser,
                })
                state.naverPayPoint.preferredPoint = {
                    sequences: preferredPointExhaustionList,
                    apiStatus: pointExhaustionListAvailable ? APIStatus.RESOLVED : APIStatus.REJECTED,
                }

                /**
                 * 페이머니 유저상태는 재조회 불가 (24.12.17)
                 * 재조회 가능 스펙 추가 시 status 필드 반영 검토 필요
                 */
                const isNaverPointAvailable = isPayMoneyUser
                    ? availablePayMethodTypes.includes(PayMethod.REWARD_POINT)
                    : (availablePayMethodTypes.includes(PayMethod.REWARD_POINT) ||
                          availablePayMethodTypes.includes(PayMethod.CHARGE_POINT)) &&
                      eq(chargePoint.chargePointUser.resultType, ApiResult.SUCCESS)

                if (isNaverPointAvailable) {
                    state.naverPayPoint.status = NaverPointStatus.ENABLE
                    state.naverPayPoint.usePointAll = usePointAll
                } else {
                    state.naverPayPoint.status = NaverPointStatus.NEVER
                }

                state.exposeAmlGuideMessage = exposeAmlGuideMessage
            })
    },
})

export default slice.reducer
